import { Button } from '@warp-ds/react';

interface Props {
    areas: string[];
    currentArea: string;
    setCurrentArea: (area: string) => void;
}

export function AreaPicker({ areas, currentArea, setCurrentArea }: Props) {
    return (
        <div className="flex pb-16 md:pb-0">
            {[...areas].reverse().map((a) => (
                <Button
                    style={{
                        backgroundColor: currentArea === a ? '#E5E5E5' : 'white',
                    }}
                    small
                    className="h-32 w-max"
                    onClick={() => setCurrentArea(a)}
                    key={`toggle-${a}`}
                >
                    {a}
                </Button>
            ))}
        </div>
    );
}
